import {useJoinStateStore} from '@/stores/cansino/joinState';
import { useLoadingStore } from '@/stores/loading';

export function toCloseLoading(){
    const oJoinStateStore = useJoinStateStore();
    const loadingStore = useLoadingStore(); 
    // ↓ 如果游戏在新窗口打开了，说明当前窗口失去了游戏权，不再关闭 loading 遮罩  
    if (oJoinStateStore.gameStartedInNewTab) {
        console.warn('游戏资格丧失，不再关闭 loading 遮罩'); 
        return;
    }
    // ↓ 初步设为0，将来按需要逐步调整此值 
    const iDelay = 0;
    setTimeout(()=>{
        // ↓ 隐藏 loading 页面  
        loadingStore.gameLoading = false;
    }, iDelay);
}

